import React from 'react';
import { Layout } from 'antd';
import { useAuth, useMetaContext, useTranslateContext, useUserConfigContext, useUserContext } from 'fennec-ui';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import { useBreadcrumbs, useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext, useMenuLevelOneContext, useMenuLevelThreeContext, useMenuLevelTwoContext } from '../../../common/Context';
import LevelBreadcrumbs from '../LevelBreadcrumbs';
import SideMenu from '../SideMenu';
import { AppstoreOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router';

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function PageLayout(props) {
    const { children, hideSider, hideBreadcrumbs, top, breadcrumbsLeft, breadcrumbsRight, bottom, sider, center } = props;
    const auth = useAuth();
    let navigate = useNavigate();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    // const langSwitch = useLangSwitchContext();

    const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
    const isMobile = useIsMobileContext();
    const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

    // const breadcrumbs = useBreadcrumbsContext()
    const breadcrumbs = useBreadcrumbs()

    const menuLevelOne = useMenuLevelOneContext()
    const menuLevelTwo = useMenuLevelTwoContext()
    const menuLevelThree = useMenuLevelThreeContext()

    const getLevel = (arr, i) => {
        let p = "/app"
        var count = 0;
        for (let idx = 0; idx < arr.length; idx++) {
            if(count >= i) return p;
            if(!arr[idx]?.context){
                count++
            }
            p+=`/${arr[idx]?.uuid}`
        }
        return p
    }
    
    // console.log(
    //     getLevel(breadcrumbs,1),
    //     getLevel(breadcrumbs,2),
    //     getLevel(breadcrumbs,3),
    //     getLevel(breadcrumbs,4),
    //     breadcrumbs,
    // );

    return (
        <div>
            {!hideBreadcrumbs && <Layout style={(!isDesktopOrLaptop) ? {} : { width: layoutWidth, margin: "0 auto" }}>
                <div style={{ backgroundColor: "white", borderRadius: "4px", marginBottom: "3px" }}>
                    <div style={{ padding: "2px", display: "flex", justifyContent: "space-between" }}>
                        {(!!breadcrumbsLeft)? breadcrumbsLeft(): <React.Fragment></React.Fragment>}
                        {(!!top) ? top() : <LevelBreadcrumbs elements={breadcrumbs} />}
                        {(!!breadcrumbsRight)? breadcrumbsRight(): <React.Fragment></React.Fragment>}
                    </div>
                </div>
            </Layout>}

            <Layout style={(!isDesktopOrLaptop) ? {} : {  borderRadius: "4px", width: layoutWidth, margin: "0 auto" }}>
                {!hideSider && <Layout.Sider width={190} theme="light" style={{ borderRadius: "4px", marginRight:"3px" }}>
                    {(!!sider) ? sider() : <div>
                        <SideMenu noDivider={true} menu={menuLevelTwo} path={getLevel(breadcrumbs,2)} />
                        <SideMenu menu={menuLevelThree} path={getLevel(breadcrumbs,3)} />
                    </div>}
                </Layout.Sider>}
                <Layout.Content style={{ backgroundColor: "white", borderRadius: "4px", minHeight: 600, height:(center)?"1px":undefined }}>
                    {children}
                </Layout.Content>
            </Layout>
            {bottom && <Layout style={(!isDesktopOrLaptop) ? { flex: "0 0 auto" } : { width: layoutWidth, margin: "0 auto" }}>
                <div style={{ backgroundColor: "white", borderRadius: "4px", marginTop: "3px" }}>
                    <div style={{ padding: "2px" }}>
                        {bottom()}
                    </div>
                </div>
            </Layout>}
        </div>
    );
}